import * as angular from "angular";

export class CustomFieldService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/customfield";
        this.v2Root = "/v2/customfield";
    }

    all(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all", data);
    }

    required(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/required", data);
    }

    types(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/types", data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/create", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/update/" + data.cfid, data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id, data);
    }

    searchValues(data: any): Promise<object> {
        const search = data.search ?? "";
        return this.$http.get(
            this.apiRoot + "/search/values/" + data.id + "/" + search,
            data
        );
    }

    getFieldValues(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/values/" + data.id);
    }
}
angular.module("vcServices").service("CustomFieldService", CustomFieldService);
